import { Suspense } from 'react';

import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { MinigiochiGuscio } from '@/lib/minigiochi';
import { useV3 } from '@/lib/v3';

/**
 * Il guscio dei minigiochi PROTETTO: l'unica cosa che `AppShell` monta (v. `tools/verify-minigiochi.ts`).
 *
 * `null` quando nessun gioco ha il flag acceso (produzione) o quando la v3 e' accesa (`useV3()`: i minigiochi stanno nella barra, ADR-0264): non monta niente. Altrimenti il guscio lazy sta dentro un `ErrorBoundary` LOCALE e un `Suspense`: un errore del bottone o del foglio (render,
 * chunk che non si carica) non deve buttare giu' tutta la shell: senza questo cadrebbe nell'`errorElement` della radice e sostituirebbe l'intera `AppShell` (riserva 2 di flotta sulla PR #749).
 * ⚠️ Il ripiego e' un frammento VUOTO e non `null`: `ErrorBoundary` fa `fallback ?? <schermata d'errore a tutto schermo>`, e `null ?? x` e' `x` — con `fallback={null}` il bottone rotto avrebbe
 * mostrato «Something went wrong» sopra l'app intera, cioe' proprio cio' che questo componente esiste per evitare.
 * Il codice non porta nessun marcatore del bottone: in produzione resta nel bundle, vuoto (`MinigiochiGuscio` e' `null`).
 */
export function GuscioProtetto() {
  // UNA condizione decide, `useV3()`: dentro la v3 i minigiochi stanno nella barra (ADR-0264) e il bottone NON si disegna (ne' il suo chunk si carica) fino al Feedback; fuori dalla v3 e' quello di sempre.
  // In produzione `useV3` e' `() => false` e `MinigiochiGuscio` e' `null`: niente.
  const v3 = useV3();
  if (!MinigiochiGuscio || v3) return null;
  return (
    <ErrorBoundary fallback={<></>}>
      <Suspense fallback={null}>
        <MinigiochiGuscio />
      </Suspense>
    </ErrorBoundary>
  );
}
